import React, { useEffect, useState } from 'react';
import { CommonService } from "../../Service/CommonService";
import { SupportApiService } from '../../Service/SupportApiService';
import { useHistory, useParams } from 'react-router';
import CKContent from '../Common/CKcontent';
import { IconButton, Table, Typography } from '@mui/material';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import "../Dynamic/UserList.scss";
import Accordion from 'react-bootstrap/Accordion';
import ExpandMore from '../../assets/images/icons/ExpandMore.svg';

const SellRequestEditHistory: React.FC = () => {
  const [history, setHistory] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const { requestId } = useParams<{ requestId: string }>();
  const { historyId } = useParams<{ historyId: string }>();
  const history1 = useHistory();
  const [activeRowIndex, setActiveRowIndex] = useState(null);

  useEffect(() => {
    const getSellRequestEditHistory = async () => {
      try {
        const response = await SupportApiService.getSellRequestEditHistory(requestId, historyId);
        setHistory(response?.data);
      } catch (error) {
        console.log("error occurred while API calling");
      } finally {
        setLoading(false);
      }
    };

    getSellRequestEditHistory();
  }, [historyId]);

  if (loading) {
    return (
      <> 
        <div className='loading-wrapper'><p>Loading...</p></div>
      </>
    ); 
  }

  if (!history) {
    return(
      <> 
        <div className='loading-wrapper'><p>No history found.</p></div>
      </>
    );
  }

  const routeBack = () => {
    history1.goBack();
  };

  // If clicking the already active row, close it
  const handleRowClick = (index) => {
    setActiveRowIndex(activeRowIndex === index ? null : index);
  };

  const getGroupedBarrelChanges = (history: any): any[] => {
    const barrelChanges = (history?.changes || []).filter(
      (field: any) => field.fieldName === 'BARREL_UPDATED'
    );

    if (barrelChanges.length === 0) return [];

    const lotGroups: { [lotNo: string]: any[] } = {};
    barrelChanges.forEach((change) => {
      const lot = change.lotNo || 'No Lot';
      if (!lotGroups[lot]) lotGroups[lot] = [];
      lotGroups[lot].push(change);
    });

   return Object.entries(lotGroups).map(([lotNo, changes]) => {

      const oldBarrels = changes.flatMap((field: any, index: number) => {

        if (field.oldValue  == '[]') {
          return [];
        }

        const splitOld = field.oldValue
          .replace(/[\[\]]/g, '') // remove square brackets
          .split(',')
          .map(b => b.trim())
          .filter(b => b);
        return splitOld;
      });

      const newBarrels = changes.flatMap((field: any, index: number) => {
        if (field.newValue == '[]') {
          return [];
        }
        const splitNew = field.newValue
          .replace(/[\[\]]/g, '') // remove square brackets
          .split(',')
          .map(b => b.trim())
          .filter(b => b);
        return splitNew;
      });

      return {
        lotNo,
        oldBarrels,
        newBarrels,
        total: newBarrels.length,
        rowKey: `barrelChange-${lotNo}`
      };
    });

  };

  const groupedBarrels = getGroupedBarrelChanges(history);

  return (
    <div className="edit-history-container usersList position-relative">
      <div className="usersList__header--wrapper d-flex flex-wrap justify-content-between align-items-center gap-2">
        <div className="d-flex flex-wrap justify-content-between gap-4">
          {CommonService.isAdmin() && (
            <div className="d-flex align-items-center gap-1">
              <>
                <div className="back__button me-1" onClick={routeBack}>
                  <IconButton
                    aria-label="ArrowBackIcon"
                    sx={{ backgroundColor: "#FFF" }}
                  >
                    <ArrowBackIcon sx={{ color: "#1C1B1F" }} />
                  </IconButton>
                </div>
                <div className="header--title me-3">
                  <h1 className="title mb-0">
                    Sell Request Edit History
                    <i className="bi bi-heart-fill"></i>
                  </h1>
                </div>
              </>
            </div>
          )}
        </div>
        <div className="header--title d-flex flex-wrap me-auto mb-xxl-0">
          <div className="time__details me-4 me-xl-4 mb-0">
            <Typography
              variant="h6"
              sx={{ color: "#333333", fontSize: "12px", fontWeight: 400 }}
            >
              Modified By
            </Typography>
            <Typography
              variant="h3"
              sx={{ color: "#333333", fontSize: "18px", fontWeight: 700 }}
            >
              {history.modifiedBy}
            </Typography>
          </div>
          <div className="time__details me-4 me-xl-4 mb-0">
            <Typography
              variant="h6"
              sx={{ color: "#333333", fontSize: "12px", fontWeight: 400 }}
            >
              Modified On
            </Typography>
            <Typography
              variant="h3"
              sx={{ color: "#333333", fontSize: "18px", fontWeight: 700 }}
            >
              {CommonService.formatDateTime(history.modifiedDate.toString())}
            </Typography>
          </div>
        </div>
      </div>

      <div className="viewSampleRequest--wrapper view_request--wrapper view_sample-wrapper viewOrderRequest--wrapper viewServiceRequest--wrapper viewSupport-req">
        <div className="no-margin w-100">
          <div className="view-sample-request m-0">
            <div className={`row m-0 inventory-file-list-table  edit-list-wrapper ${CommonService.isAdmin() && "admin-edit-list-wrapper"}`}>
              {/* left side showing inventory barrel changes */}
              <div className="col-xl-6 mb-4 mb-xl-0">
                <div className="table-responsive service-detail-table-wrapper">
                  <Table className="service-detail-table mb-0">
                    <thead>
                      <tr>
                        <th className="text-start">Inventory</th>
                        <th className="text-nowrap">Quantity</th>
                      </tr>
                    </thead>
                    <tbody>
                      {groupedBarrels.length === 0 ? (
                        // <tfoot>
                          <tr>
                            <td
                              colSpan={3}
                              className="text-center text-muted py-3"
                            >
                              No container changes found.
                            </td>
                          </tr>
                        // </tfoot>
                      ) : (
                        groupedBarrels.map(
                          ({
                            lotNo,
                            oldBarrels,
                            newBarrels,
                            total,
                            rowKey,
                          }) => (
                            <React.Fragment key={rowKey}>
                              <tr
                                style={{
                                  borderColor:
                                    activeRowIndex === rowKey
                                      ? "transparent"
                                      : "#E4E4DD",
                                }}
                              >
                                <td className="text-start">
                                  Container Change - {lotNo}
                                </td>
                                <td className="text-nowrap">
                                  <button
                                    onClick={() => handleRowClick(rowKey)}
                                    className="barrel-count-btn ms-1"
                                    style={{
                                      borderColor:
                                        activeRowIndex === rowKey
                                          ? "#3A809E"
                                          : "#8F9195",
                                      color:
                                        activeRowIndex === rowKey
                                          ? "#3A809E"
                                          : "#737376",
                                    }}
                                  >
                                    {total}
                                    <span className="p-1">
                                      <img
                                        src={ExpandMore}
                                        alt="Expand"
                                        width={15}
                                        height={8}
                                      />
                                    </span>
                                  </button>
                                </td>
                              </tr>

                              {activeRowIndex === rowKey && (
                                <tr className="total-barrel-wrapper">
                                  <td colSpan={2}>
                                    <Accordion activeKey="0">
                                      <Accordion.Item eventKey="0">
                                        <Accordion.Body className="px-0 py-0">
                                          <div className="total-barrel-list-wrapper edit-sell-barrel">
                                            {/* Previous Barrels  */}
                                            <div className="barrel-list-wrapper">
                                              <div className="title">
                                                Previous
                                              </div>
                                              <div className="barrel-list d-flex align-items-center flex-wrap gap-2">
                                                {oldBarrels.length > 0 ? (
                                                  oldBarrels.map(
                                                    (
                                                      barrel: string,
                                                      idx: number
                                                    ) => (
                                                      <div
                                                        key={idx}
                                                        className="barrel-list-item"
                                                      >
                                                        {barrel}
                                                      </div>
                                                    )
                                                  )
                                                ) : (
                                                  <div className="text-muted">
                                                    No container were previously
                                                    associated with this lot
                                                  </div>
                                                )}
                                              </div>
                                            </div>

                                            {/* Current Container */}
                                            <div className="barrel-list-wrapper new-barrels mt-2">
                                              <div className="new-barrels-inner">
                                                <div className="title">
                                                  Current
                                                </div>
                                                <div className="barrel-list d-flex align-items-center flex-wrap gap-2">
                                                  {newBarrels.length > 0 ? (
                                                    newBarrels.map(
                                                      (
                                                        barrel: string,
                                                        idx: number
                                                      ) => (
                                                        <div
                                                          key={idx}
                                                          className="barrel-list-item"
                                                        >
                                                          {barrel}
                                                        </div>
                                                      )
                                                    )
                                                  ) : (
                                                    <div className="text-muted">
                                                      All Containers ware removed
                                                      from this lot
                                                    </div>
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </Accordion.Body>
                                      </Accordion.Item>
                                    </Accordion>
                                  </td>
                                </tr>
                              )}
                            </React.Fragment>
                          )
                        )
                      )}
                    </tbody>
                  </Table>
                </div>
              </div>

              <div className="col-xl-6">
                <div className="service-detail-right edit-sell-right">
                  <div className="row">
                    {(() => {
                      const nonBarrelChanges =
                        history?.changes?.filter(
                          (field: any) => field.fieldName !== "BARREL_UPDATED"
                        ) || [];

                      // const hasVisibleChanges = nonBarrelChanges.some(
                      //   (field: any) => field.oldValue !== field.newValue
                      // );

                      // if (!hasVisibleChanges) {
                      //   return (
                      //     <div className="col-12">
                      //       <div className="text-muted px-2 py-2 text-center">
                      //         No other field changes were recorded.
                      //       </div>
                      //     </div>
                      //   );
                      // }

                      const normalFields = nonBarrelChanges.filter(
                        (field: any) =>
                          field.fieldName !== "Description" &&
                          field.fieldName !== "Comment"
                      );
                      
                      const descriptionField = nonBarrelChanges.find(
                        (field: any) => field.fieldName === "Description"
                      );

                      const commentField = nonBarrelChanges.find(
                        (field: any) => field.fieldName === "Comment"
                      );

                      return (
                        <>
                          {/* Normal Fields */}
                          {normalFields.map((field: any, idx: number) => {
                            const label = field.fieldName || "-";
                            const originalValue = field.oldValue || "-";
                            const editedValue = field.newValue || "-";
                            const hasChanged = originalValue !== editedValue;

                            return (
                              <div
                                className="col-12 col-sm-6 col-lg-4 col-xl-4 content-outer"
                                key={idx}
                              >
                                <div className="content-wrapper">
                                  <p className="content-title">{label}</p>
                                  <div className="title-bottom-line"></div>
                                  <div className="d-flex gap-2 align-items-center flex-wrap value">
                                    {hasChanged && (<div>
                                      <span
                                        className={
                                          hasChanged
                                            ? "old-value text-decoration-line-through"
                                            : ""
                                        }
                                      >
                                        {label == 'Price' && '$'}{originalValue}
                                      </span>
                                    </div>)}
                                    <span>
                                      <span>{label == 'Price' && '$'}{editedValue}</span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                          {descriptionField && (
                            <div className="col-12 content-outer comment-outer">
                              <div className="content-wrapper">
                                    <p className="content-title">Description</p>
                                    <div className="title-bottom-line"></div>
                                    <div className="d-flex flex-column value">
                                     {descriptionField.oldValue != descriptionField.newValue && (<div>
                                        <span>
                                          <CKContent
                                            content={descriptionField.oldValue || "-"}
                                            className="old-value"
                                          />
                                        </span>
                                      </div>)}
                                      <span>
                                        <CKContent content={descriptionField.newValue || "-"} />
                                      </span>
                                    </div>
                              </div>
                            </div>
                          )}

                          {commentField && (
                            <div className="col-12 content-outer comment-outer">
                              <div className="content-wrapper">
                                    <p className="content-title">Comment</p>
                                    <div className="title-bottom-line"></div>
                                    <div className="d-flex flex-column value">
                                     {commentField.oldValue != commentField.newValue && (<div>
                                        <span>
                                          <CKContent
                                            content={commentField.oldValue || "-"}
                                            className="old-value"
                                          />
                                        </span>
                                      </div>)}
                                      <span>
                                        <CKContent content={commentField.newValue || "-"} />
                                      </span>
                                    </div>
                                  </div>
                            </div>
                          )}

                        </>
                      );
                    })()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SellRequestEditHistory;